<template>
  <v-row>
    <v-col v-bind:key="data.flipped">
      <section v-if="!data.flipped" class="card card-front">
        <section class="section-image" :style="sectionStyle">
          <v-img
            :src="require('@/assets/img/user.png')"
            class="img-photo"
            fixed
          >
          </v-img>
        </section>
        <section class="section-title pl-2 pr-2">
          <h4 style="font-weight: 300;" class="text-uppercase">{{ data.name +' '+ data.lastname }}</h4>
        </section>

        <section class="section-position pl-2 pr-2">
          <h5 style="font-weight: 400;" class="text--secondary">
            {{ data.institution }}
          </h5>
        </section>

        <section class="section-flag">
          <v-img
            v-bind:src="url_flag"
            class="img-flag"
            fixed
          >
          </v-img>
        </section>

        <section class="section-provincia pl-2 pr-2">
          <h5 style="font-weight: 400;" class="text--secondary">
            {{ (data.country.name.toLowerCase()=='argentina')?data.provincia.name:data.other_provincia }}
          </h5>
        </section>


        <section class="section-social">

          <div @click="handleIconClick(data.user_id)">
            <v-icon>mdi-message-outline</v-icon>
          </div>

          <a v-if="data.web" :href="data.web" target="_blank">
            <v-icon>
              mdi-web
            </v-icon>
          </a>

          <a v-if="data.linkedin" :href="data.linkedin" target="_blank">
            <v-icon>
              mdi-linkedin
            </v-icon>
          </a>
          
          <a v-if="data.facebook" :href="data.facebook" target="_blank">
            <v-icon>
              mdi-facebook
            </v-icon>
          </a>
          
          <a v-if="data.instagram" :href="data.instagram" target="_blank">
            <v-icon>
              mdi-instagram
            </v-icon>
          </a>

          <a v-if="data.twitter" :href="data.twitter" target="_blank">
            <v-icon>
              mdi-twitter
            </v-icon>
          </a>

          <a v-if="data.youtube" :href="data.youtube" target="_blank">
            <v-icon>
              mdi-youtube
            </v-icon>
          </a>

          <a v-if="data.whatsapp" :href="data.whatsapp" target="_blank">
            <v-icon>
              mdi-whatsapp
            </v-icon>
          </a>

          <a v-if="data.telegram" :href="data.telegram" target="_blank">
            <v-icon>
              mdi-send
            </v-icon>
          </a>

          <a v-if="data.discord" :href="data.discord" target="_blank">
            <v-icon>
              mdi-discord
            </v-icon>
          </a>

          <a v-if="data.twitch" :href="data.twitch" target="_blank">
            <v-icon>
              mdi-twitch
            </v-icon>
          </a>

          <a v-if="data.tiktok" :href="data.tiktok" target="_blank">
            <v-img  
                contain
                height="20px" 
                width="20px"
                position="center" 
                :src="require('@/assets/icons/tiktok.png')">
              </v-img>
          </a>

          <a v-if="data.snapchat" :href="data.snapchat" target="_blank">
            <v-icon>
              mdi-snapchat
            </v-icon>
          </a>

          <a v-if="data.email" :href="'mailto:'+data.email" target="_blank">
            <v-icon>
              mdi-email
            </v-icon>
          </a>
        </section>

      </section>

      <section v-if="data.flipped" class="card card-back overflow-auto">
        {{ data.description }}
      </section>  
    </v-col>

    <v-dialog
      v-model="dialog_message"
      persistent
      max-width="380"
    >
      <v-card>
        <v-card-title class="text-h5">
          Mensaje privado
        </v-card-title>
        <v-card-text>
          {{ data.name+ ' ' + data.lastname }}
          
            <v-textarea
              outlined
              class="pt-4"
              name="input-7-4"
              label="Mensaje"
              v-model="message"
            ></v-textarea>

        </v-card-text>
        <v-card-actions>
          <v-btn
            color="primary"
            text
            @click="dialog_message = false"
          >
            Cancelar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!message"
            color="primary"
            text
            @click="sendMessage()"
            :loading="loading_send"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-row>
</template>
<script>
  import axios from 'axios'
  const APP_URL = process.env.VUE_APP_URL

  export default {
    name: 'cardAssistant',
    props:['data', 'backgroundCardAssistant'],

    data: () => ({
      show_card:false,
      loading:false,
      loading_send:false,
      dialog_message:false,
      message:'',
      flipped: false,
      newFront: '',
      newBack: '',
      error: false,

      url_photo:null,
      base_url: null
    }),
    computed: {
      sectionStyle() {
        return {
          backgroundImage: `linear-gradient(to bottom, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.9)), url(${this.backgroundCardAssistant})`
        }
      }
    },
    methods:{    
      createURL(){
        this.url_photo = this.base_url + this.data.photo
        this.url_flag = this.base_url + this.data.country.flag
        this.show_card = true
      },

      toggleCard: function() {
        this.data.flipped = !this.data.flipped;
      },

      handleIconClick(id){
        this.data.flipped=false
        this.receiver_id = id
        this.message = ''
        this.dialog_message = true
      },

      async sendMessage()
      {
        try {
          this.loading_send = true
          await axios.post('messages',{
            message: this.message, 
            receiver_id: this.receiver_id, 
            }).then(response =>{
              this.message = ''
              this.dialog_message = false
              this.loading_send = false
              console.log(response)
            })
          } catch (error) {
              this.message = ''
              this.dialog_message = false
              this.loading_send = false
              console.error(error.response.data);     // NOTE - use "error.response.data` (not "error")
          }
      }
    },
    created() {
      this.base_url = APP_URL
      this.createURL()
    }
  }
</script>

<style type='text/css' scoped>
ul {
  padding-left: 0;
  display: flex;
  flex-flow: row wrap;
}

li {
  list-style-type: none;
  padding: 10px 10px;
  transition: all 0.3s ease;
}

.container {
  max-width: 100%;
  padding: 2em;
}
.card {
  outline: 1px solid #E0E0E0;
  height: 376px;
  width: 240px!important;
  background-color: #ffffff;
  border-radius: 8px;
  line-height: 27px;
  position: relative;
  color: #000000;
  box-shadow: 0 0 15px rgb(0 0 0 / 0.2);
}
.card-front {
  display: block;
  text-align: center;
  font-weight: 300;
  font-size: 18px;
}
.card-back {
  display: block;
  text-align: center;
  font-weight: 300;
  font-size: 18px;
}
.img-photo {
  max-height: 116px;
  max-width: 116px;
  min-height: 116px;
  min-width: 116px;
  border-radius: 50%; 
}
.img-flag{
  height: auto;
  max-width: 32px;
}
.section-image {
  display: flex;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  justify-content: center;
  align-items: center;
  height: 140px;
  background-size: contain;
  background-repeat: repeat;
  background-position: center;
}
.section-title {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 58px;
}
.section-position {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 42px;
}
.section-flag {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 4px;
  height: 40px;
}
.section-provincia {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: -8px;
  height: 30px;
}
.section-social {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  overflow-x: hidden;
  height: 72px;
  flex-wrap: wrap;
  margin-left: 10px;
  margin-right: 10px;
}

</style>